import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { Noto_body2_m14, Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import recommend_app_installation from 'src/assets/images/modal/recommend_app_installation.png'
import { useModal } from 'src/provider/ModalContextProvider'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import LazyImage from 'src/components/common/LazyImage'
import { css } from 'styled-components'
import { useCookies } from 'react-cookie'
import { DateUtils } from 'src/utils/date'
import { mobileOS } from 'src/utils'
import { aosAppStoreLink, aosOpenApp, iosInstallDeepLink } from 'src/utils/windowOpen'

const RecommendAppInstallation = () => {
  const { closeModal } = useModal()
  const { cookieRestTodayTime } = DateUtils
  const [, setCookie] = useCookies(['app_install_popup'])
  const os = mobileOS()

  const openApp = () => {
    if (os === 'android') {
      window.location.href = aosOpenApp(aosAppStoreLink)
    } else if (os === 'ios') {
      window.location.href = iosInstallDeepLink
    } else {
      closeModal()
    }
  }

  const remainWeb = () => {
    setCookie('app_install_popup', true, {
      path: '/',
      expires: cookieRestTodayTime(),
    })
    closeModal()
  }

  return (
    <Container $option="flex_column" $row_gap="26px">
      <Container $option="flex_column" $row_gap="10px">
        <Typography $fontStyle={Noto_subheading_b18}>
          휴대폰 쿠폰지갑 앱에서는 <br />
          간편하게 로그인이 가능해요.
        </Typography>
        <LazyImage
          src={recommend_app_installation}
          alt="앱 설치 권장 이미지"
          style={S.RecommendAppInstallation.Image}
        />
      </Container>
      <Container $option="flex_column" $row_gap="15px">
        <Button option={ButtonOption3('active')} onClickFn={openApp}>
          앱에서 보기
        </Button>
        <Typography $fontStyle={Noto_body2_m14} $color={'var(--black-50)'} onClick={remainWeb}>
          오늘은 모바일웹에서 볼게요
        </Typography>
      </Container>
    </Container>
  )
}
export default RecommendAppInstallation

const S = {
  RecommendAppInstallation: {
    Image: css`
      width: 100%;
      min-height: 100px;
    `,
  },
}
